import * as yup from 'yup';
import { PriceEstimateWithServicePlanPageFormData } from './PriceEstimateWithServicePlanPageFormData';

export const priceEstimateWithServicePlanPageFormSchema: yup.SchemaOf<PriceEstimateWithServicePlanPageFormData> = yup.object({
  termsAndConditionsAccepted: yup.bool().label('Accept the terms and conditions').required().isTrue(),
});
